import { Box } from '@mui/material';
import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';

import { useGetContactsQuery } from '@/api/v1';
import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useCustomer } from '@/hooks/useCustomer';
import { useTranslator } from '@/hooks/useTranslator';
import { PaymentMethodFiat } from '@/Screens/Dashboard/Contacts/PaymentMethodFiat';
import { Contact, SelfContact } from '@/types/contacts';
import { ModalFlowContext } from '@/types/modalFlowContext';

export const PaymentMethodModal: React.FC = (): React.ReactElement => {
  const tr = useTranslator();
  const customer = useCustomer();
  const modal = useOutletContext<ModalFlowContext>();

  const { contactId = null } = useParams();

  const onCreated = React.useCallback(
    (id: string): void => {
      modal.close({
        accountId: id,
      });
    },
    [modal],
  );

  const { data = [] } = useGetContactsQuery(customer.beneficiaryId, {
    skip: !contactId,
  });

  const contact = React.useMemo(
    (): Contact | SelfContact | undefined =>
      contactId
        ? data.find((contact: Contact): boolean => contact.id === contactId)
        : SelfContact.fromCustomer(customer),
    [customer, data, contactId],
  );

  const onClose = React.useCallback((): void => {
    modal.close();
  }, [modal]);

  return (
    <ApplicationModal title={tr('PAYMENT_METHOD')} back=".." onClose={onClose}>
      <Box display="flex" flexDirection="column" gap={5}>
        <PaymentMethodFiat onCreated={onCreated} contact={contact} redirectPath={modal.closePath} />
      </Box>
    </ApplicationModal>
  );
};
